import RegionSet from "../region-sets/regionSet";

interface Resource {
  resourceId: number;
  clientId: number;
  userId: number;
  name: string;
  description: string;
  isPrivate: boolean;
  folderId?: number;
  dateCreated?: Date;
  dateLastUpdated?: Date;
  dateArchived?: Date;
  datePurged?: Date;
  resourceStatus: ResourceStatus;
  resourceType: ResourceType;
  isSystemResource: boolean;
  isArchived: boolean;
  isHidden: boolean;
  isShared: boolean;
}

enum ResourceType {
  Unknown = "unknown",
  Project = "project",
  ProviderSet = "providerSet",
  MemberSet = "memberSet",
  SpecialtyList = "specialtyList",
  CensusFile = "censusFile",
  Folder = "folder",
  Category = "category",
  FilteredProviderSet = "filteredProviderSet",
  FilteredMemberSet = "filteredMemberSet",
  AdequacyTemplateCollection = "adequacyTemplateCollection",
  CustomProject = "customProject",
  ZipAnalysisProject = "zipCodeAnalysisProject",
  AdequacyZipTemplateCollection = "adequacyZipTemplateCollection",
  SpecialtyException = "specialtyException"
}

enum ResourceStatus {
  Active = 1,
  Archived = 2,
  PurgeRequested = 3,
  Purged = 4,
}

interface FilteredResource {
  filterPath: string;
  resourceId: number;
  serviceAreaRegionSets: RegionSet[];
  specialtyGroupCodes: string[];
}

export {
  FilteredResource,
  Resource as default,
  ResourceStatus,
  ResourceType,
};
